// AUTO-CONVERTED FROM SPROCKETS
// Original file: app/assets/javascripts/shared/lib/customers_url.js

/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
function edit_url_fragment(customer_id, language_code) {
  return `company_cv/${language_code}/customer/${customer_id}`;
}

export function edit_path(customer_id, language_code) {
  const fragment = edit_url_fragment(customer_id, language_code);

  return `/tools#/${fragment}`;
}
